import { useMemo } from 'react';

import transformModelToProps from '@/utils/transform-model-props';

const useTransformModelToProps = <T extends { model?: any; cqPath?: string }>(
	originalProps?: T,
	itemsListKey?: keyof T['model'],
) => {
	const transformedProps = useMemo(() => {
		if (!itemsListKey || !originalProps?.model) return originalProps;
		return transformModelToProps(originalProps, itemsListKey);
	}, [originalProps, itemsListKey]);

	return transformedProps;
};

export default useTransformModelToProps;
